var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"health"},[_c('div',{staticClass:"healthy"},[_c('van-image',{staticClass:"img",attrs:{"src":require('@/assets/m-img-1.png'),"height":"410","width":"100%","fit":"contain"}})],1),_c('div',{staticClass:"healthy_download"},[_c('a',{attrs:{"href":_vm.url}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }